import "babel-polyfill"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import Toasted from "vue-toasted"
import VueClipboard from "vue-clipboard2"
import Skeleton from "vue-loading-skeleton"
import Ads from "vue-google-adsense"
import VS2 from "vue-script2"
import "./plugins/vuetify"
import "./plugins/axios"
import "./plugins/my"

Vue.config.productionTip = false
console.log(`version: ${process.env.VUE_APP_VERSION || "local"}`)
Vue.use(Skeleton)
Vue.use(VueClipboard)
Vue.use(VS2)
Vue.use(Ads.Adsense, { adClient: "7038131727768741" })
Vue.use(Toasted, {
  position: "top-center",
  duration: 3000,
  icon: "error_outline",
  className: "toast"
})

Vue.prototype.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
